import React, { ReactElement } from 'react';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Utils

import { createSignature } from '@utils/householdMember/createSignature';
import { householdMemberTools } from '@utils/tools/householdMemberTools';
import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { HouseholdMembers } from '../../../SsapTypes';

interface ISignatureAttestation {
    actions: {
        onFieldBlur_signing: Function,
        onFieldChange_signing: Function
    },
    formName: string,
    householdMembers: HouseholdMembers,
    labelClasses: Array<string>,
    signature: string
}



const SignatureAttestation = (props: ISignatureAttestation): ReactElement => {
    const {
        actions: {
            onFieldBlur_signing,
            onFieldChange_signing
        },
        formName,
        householdMembers,
        labelClasses = [],
        signature
    } = props;

    const {
        name: householdHeadName
    } = householdMemberTools.getPrimaryContact(householdMembers);

    return (
        <UniversalInput
            label = { {
                text: 'ssap.input.label.person_esignature',
                labelClasses: [ 'text-break', ...labelClasses ],
                labelTextReplacements: {
                    personName: (
                        <strong>
                            { normalizeNameOfPerson(householdHeadName) }
                        </strong>
                    )
                }
            } }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.REGULAR_INPUT,
                name: 'signature',
                helperClasses: [ ],
                value: signature,
                valuesToMatch: createSignature(householdHeadName),
                placeholder: 'ssap.input.placeholder.type_full_name',
                validationType: VALIDATION_TYPES.IS_SIGNED,
                currentData: { signature },
                fields: [ ]
            }}
            inputActions = { {
                onFieldChange: onFieldChange_signing,
                onFieldBlur: onFieldBlur_signing
            } }
            underFormControl
            parentForm = { { name: formName } }
            errorClasses = { [ 'margin-l-0' ] }
        />
    );
};

export default SignatureAttestation;